import queryString from './queryString';

export const getFeatureFlag = (featureFlag: string) => {
    const params = queryString.parse(window.location.search);
    if (params[featureFlag]) {
        return params[featureFlag];
    }
    return process.env[`REACT_APP_${featureFlag}`];
};
